export const LOAD_ACTIVITIES = 'processingactivities/LOAD_ACTIVITIES';

export const ACTIVITIES_LOADING = 'processingactivities/ACTIVITIES_LOADING';
export const DETAILS_LOADING = 'processingactivities/DETAILS_LOADING';
export const SET_ACTIVITIES_SHOWALL = 'processingactivities/SET_ACTIVITIES_SHOWALL';

export const SET_SELECTED_DETAIL_ACTIVITY_DIRTY = 'processingactivities/SET_SELECTED_DETAIL_ACTIVITY_DIRTY';
export const LOAD_ACTIVITYDETAILS = 'processingactivities/LOAD_ACTIVITYDETAILS';

export const LOAD_WAITING_ACTIVITIES = 'processingactivities/LOAD_WAITING_ACTIVITIES';
export const LOAD_DELEGATED_ACTIVITIES = 'processingactivities/LOAD_DELEGATED_ACTIVITIES';
export const LOAD_MY_ACTIVITIES = 'processingactivities/LOAD_MY_ACTIVITIES';





